import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface SiretValidatorError {
  siret: true;
}

export const SiretValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const REGEX_SIRET = '^[0-9]{14}'; // @@@
  const regexp = new RegExp(REGEX_SIRET);
  return !control.value || regexp.test(control.value) ? null : ({ siret: true } as SiretValidatorError);
};
